import { TextInput, MultilineInput, Checkbox, Collection } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { ProductCategory } from "../../../Models/Product/ProductCategory";
import { SinglePictureEdit } from "../../Main/SinglePictureEdit";
import { BlogArticle } from "../../../Models/Blog/BlogArticle";
import { ArticleSelector } from "./ArticleSelector";
import { FormRow, FormPrinter } from "../../Product/InputsPrinter";


export class CategoryEditContent extends FormPrinter
{
    constructor(category: ProductCategory, articles: Collection<BlogArticle>)
    {
        super([
            new FormRow("Id", new TextInput(category.Id).Placeholder("Id (musi być unikalne)")),
            new FormRow("Url", new TextInput(category.Url).Placeholder("Url (ten w pasku przeglądarki)")),
            new FormRow("Widoczny na stronie", new Checkbox(category.Visible)),
            new FormRow("Tytuł", new TextInput(category.Title).Placeholder("")),
            new FormRow("Pod tytułem", new TextInput(category.Subtitle).Placeholder("")),
            new FormRow("Obrazek", new SinglePictureEdit(category.Image)),
            new FormRow("Opis (przy liście produktów)", new MultilineInput(category.Description).Rows(4).Placeholder("Markdown")),
            new FormRow("Powiązane artykuły", new ArticleSelector(category, articles))
        ]);
    }
}
